import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {AssetsService} from '../../../services/assets.service';
import {beforeUnloadEvent} from '../../../../core/utils/utils';
import {ConfigurationService} from '../../../../core/services/impl/configuration/configuration.service';
import {PartnerService} from '../../../services/partner.service';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {NotificationBase} from '../../../components/abstract/notification-base';

@Component({
  selector: 'app-session-error-notification-web',
  templateUrl: './session-error-notification-web.component.html',
  styleUrls: ['./session-error-notification-web.component.scss']
})
export class SessionErrorNotificationWebComponent extends NotificationBase implements OnInit {

  constructor(private router: Router,
              urlParamsService: UrlParamsService,
              partnerService: PartnerService,
              private configuration: ConfigurationService,
              private assetsService: AssetsService) {
    super(urlParamsService, partnerService);
    this.router.navigate(['']);
  }

  ngOnInit() {
  }

  refreshApp() {
    if (!this.anchorButton) {
      window.removeEventListener('beforeunload', beforeUnloadEvent);
      window.location.reload();
      window.addEventListener('beforeunload', beforeUnloadEvent);
    }
  }

  get imageUrl(): string {
    return this.assetsService.informationDialogImageSrc;
  }

  get logoUrl(): string {
    return this.configuration.uiConfig.headerConfig.logo.url;
  }
}
